var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgStudioGrayIcon = function SvgStudioGrayIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    fill: "none",
    role: "img",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#studio_gray_icon_svg__a)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#c1c1c1",
    d: "m14.26 22.66-1.13-1.88a1.25 1.25 0 0 0-2.12-.04L4.6 30.6a2.5 2.5 0 0 1-4.2-2.72l6.42-9.87a6.25 6.25 0 0 1 10.6.19l.15.26-3.3 4.2z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#studio_gray_icon_svg__b)",
    fillOpacity: 0.5,
    d: "m14.26 22.66-1.13-1.88a1.25 1.25 0 0 0-2.12-.04L4.6 30.6a2.5 2.5 0 0 1-4.2-2.72l6.42-9.87a6.25 6.25 0 0 1 10.6.19l.15.26-3.3 4.2z",
    style: {
      mixBlendMode: "color-burn"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#bcbcbc",
    d: "m20.5 23.32 1.48 2.47c.46.78 1.59.81 2.1.06L35.44 9.22a2.5 2.5 0 0 1 4.12 2.81L28.21 28.67a6.25 6.25 0 0 1-10.52-.3l-.62-1.04 3.42-4.01z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#studio_gray_icon_svg__c)",
    fillOpacity: 0.5,
    d: "m20.5 23.32 1.48 2.47c.46.78 1.59.81 2.1.06L35.44 9.22a2.5 2.5 0 0 1 4.12 2.81L28.21 28.67a6.25 6.25 0 0 1-10.52-.3l-.62-1.04 3.42-4.01z",
    style: {
      mixBlendMode: "color-burn"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ababab",
    d: "m11 20.74 1.25-1.82c1.3-1.9 3.98-2.7 5.16-.72l4.57 7.59c.42.7 1.37.8 1.93.26l-1.13 1.63c-1.28 1.87-3.92 2.63-5.09.68l-4.56-7.58a1.25 1.25 0 0 0-2.12-.04z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#studio_gray_icon_svg__d)",
    fillOpacity: 0.5,
    d: "m11 20.74 1.25-1.82c1.3-1.9 3.98-2.7 5.16-.72l4.57 7.59c.42.7 1.37.8 1.93.26l-1.13 1.63c-1.28 1.87-3.92 2.63-5.09.68l-4.56-7.58a1.25 1.25 0 0 0-2.12-.04z",
    style: {
      mixBlendMode: "multiply"
    }
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: 11.25,
    x2: 4.69,
    y1: 10.63,
    y2: 21.25,
    gradientUnits: "userSpaceOnUse",
    id: "studio_gray_icon_svg__b"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ababab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ababab",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 28.13,
    x2: 18.44,
    y1: 17.5,
    y2: 31.25,
    gradientUnits: "userSpaceOnUse",
    id: "studio_gray_icon_svg__c"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ababab",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ababab"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 12.81,
    x2: 20.94,
    y1: 17.81,
    y2: 29.38,
    gradientUnits: "userSpaceOnUse",
    id: "studio_gray_icon_svg__d"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b2b2b2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#ababab",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bcbcbc"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "studio_gray_icon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 4a4 4 0 0 1 4-4h32a4 4 0 0 1 4 4v32a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4z"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgStudioGrayIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/studio_gray_icon.a58bb413.svg";